import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { InputMoneyProps } from '../../../../../../../components/InputMoney';
import { AssetSelectedTypeMap } from '../../../../../../../store/product/types';
import { useDirectTreasuryAddedProductItem } from '../../../../../hooks';
import {
  AddedProductItemList,
  AddedProductItemRouteParamTypeProps,
  AssetWithErrorResponse,
} from '../../../../../utils/types';
import { AddedProductItemContainer } from '../Container';

import { AddedProductItemDirectTreasuryDesktop } from './desktop';
import { AddedProductItemDirectTreasuryMobile } from './mobile';
import { AddedProductItemDirectTreasurySkeleton } from './skeleton';
import { AddedProductItemDirectTreasuryTablet } from './tablet';

type DirectTreasuryData = AssetSelectedTypeMap['directTreasury'] & AssetWithErrorResponse;

export interface AddedProductItemDirectTreasuryProps {
  data: DirectTreasuryData;
  type: AddedProductItemRouteParamTypeProps;
  isInvalid?: boolean;
  orderIsRecused?: boolean;
}

export interface AddedProductResponsiveItemDirectTreasuryProps {
  data: DirectTreasuryData;
  onRemoveProduct: () => void;
  inputMoneyDataProps: InputMoneyProps;
  messageAdjustUnitPriceIsVisible: boolean;
  handleChangeAmountItem: (value: number) => void;
  inputIsFocused: boolean;
  amountItem: number;
  inputIsDisabled: boolean;
}

export const AddedProductItemDirectTreasury: React.FC<AddedProductItemDirectTreasuryProps> = ({
  data,
  type,
  isInvalid,
  orderIsRecused,
}) => {
  const {
    onRemoveProduct,
    inputMoneyDataProps,
    messageAdjustUnitPriceIsVisible,
    inputIsFocused,
    amountItem,
    handleChangeAmountItem,
    isLoadingAction,
    inputIsDisabled,
  } = useDirectTreasuryAddedProductItem({ data, type });

  const lateralBarBackgroundColor = isInvalid ? 'feedback.attention.lightest' : 'product.tesouro';

  const params = {
    onRemoveProduct,
    inputMoneyDataProps,
    messageAdjustUnitPriceIsVisible,
    inputIsFocused,
    amountItem,
    handleChangeAmountItem,
    data,
    lateralBarBackgroundColor,
    inputIsDisabled,
  };

  const layout = useBreakpointValue({
    base: <AddedProductItemDirectTreasuryMobile {...params} />,
    sm: <AddedProductItemDirectTreasuryTablet {...params} />,
    lg: <AddedProductItemDirectTreasuryDesktop {...params} />,
  });

  if (isLoadingAction) {
    return <AddedProductItemDirectTreasurySkeleton />;
  }

  return (
    <AddedProductItemContainer
      data={data as AddedProductItemList}
      isInvalid={!!isInvalid}
      key={data.productId}
      orderIsRecused={!!orderIsRecused}
      lateralBarBackgroundColor={lateralBarBackgroundColor}>
      {layout}
    </AddedProductItemContainer>
  );
};
